<template>
  <dg-field-container :field_mark="field_mark" :field_span="field_span" :label_span="label_span"
                      style="min-height: 200px">
    <template v-slot:label>
      <dg-label-field :label="label" :translate="translateLabel" v-if='label'></dg-label-field>
    </template>
    <template v-slot:field>
      <el-upload
          ref="attachmentUploader"
          action="/" :auto-upload="false"
          :on-change="onChange"
          :file-list="files"
          multiple
          :on-exceed="limitExceeded"
          :limit="maxAllowedFiles"
          list-type="picture-card"
          class="avatar-uploader"><i class="el-icon-plus" slot="default"></i>
        <div slot="file" slot-scope="{file}">
          <img :src="file.previewImage" alt="" class="avatar" style="width: 200px;">
          <div class="filename" v-if="file.newFile">{{file.name}}</div>
          <span class="el-upload-list__item-actions">
              <span @click="handlePictureCardPreview(file)" class="el-upload-list__item-preview mr-2" v-if="viewEvent">
                  <i class="el-icon-zoom-in"></i>
              </span>
              <span @click="handleDownload(file)" class="el-upload-list__item-delete mr-2" v-if="downloadEvent && !file.newFile">
                <i class="el-icon-download"></i>
              </span>
              <span @click="handleRemove(file)" class="el-upload-list__item-delete mr-2">
                <i class="el-icon-delete"></i>
              </span>
          </span>
        </div>
      </el-upload>
      <!--<div class="filename" v-if="newFile">{{file.name}}</div>
      <el-button @click="handleDownload(file)" icon="el-icon-download" size="mini" v-if="downloadEvent && !newfile">
        save
      </el-button>
      <el-button @click="handlePreview(file)" icon="el-icon-view" size="mini" v-if="viewEvent && !newfile">view
      </el-button>-->
      <slot name="field_note"></slot>
      <div class="error-field-validate-message" v-if="validateMessage">{{ validateMessage }}</div>
    </template>
  </dg-field-container>
</template>

<script>
import inputField from '../mixins/inputField';

export default {
  mixins: [inputField],
  props: {
    removeFileFromBackend: {
      required: true
    },
    filesLimit: {
      required: false,
      default: 6
    },
    fileToLoad: {
      required: false,
      type: Object
    },
    label: {
      required: true,
      type: String
    },
    allowedExt: {
      required: true,
      type: Array
    },
    fileSizeLimit: {
      required: false,
      default: 2 // in MB
    },
    downloadEvent: {
      required: false,
      default: false
    },
    viewEvent: {
      required: false,
      default: false
    }
  },
  beforeMount() {
    this.maxAllowedFiles = this.filesLimit
  },
  data() {
    return {
      maxAllowedFiles: 1,
      featureDisabled: true,
      files: [],
      newFile: false,
      binding: 'storage-upload',
      readyForDownload: false,
      previewImage: '',
      extAndIcons: {
        'pdf': 'file',
        'xls': 'file',
        'xlsx': 'file',
        'mp3': 'file',
        'mp4': 'file',
      }
    };
  },
  methods: {
    handleRemove(file, index) {
      let files = this.$refs.attachmentUploader.uploadFiles;
      let filesCount = files.length;
      for (let i = 0; i < filesCount; i++) {
        if (file.uid === files[i].uid) {
          files.splice(i, 1)
          this.setFile(this.files.splice(i, 1))
          break
        }
      }
      if (file.hasOwnProperty('id')) {
        this.removeFileFromBackend(file)
      }
    },
    limitExceeded () {
      this.$message.error('Max allowd files is ' + this.maxAllowedFiles);
    },
    prepareForEvent(file) {
      file.isImage = this.fileIsImage(file.mime)
      if (file.isImage) {
        if (file.newFile) {
          file.image = URL.createObjectURL(file.content)
        } else {
          file.image = file.download_link
        }

      }
      return file
    },
    handleDownload(file) {
      console.log('handleDownload', file)
      this.downloadEvent(this.prepareForEvent(file))
    },
    handlePreview(file) {
      this.viewEvent(this.prepareForEvent(file))
    },
    setFile(files) {
      for( let f in files) {
        $store.dispatch('Storage-File-api/info', files[f]).then( r => {
          if (!r.hasOwnProperty('length')) {
            let tempFile = r
            tempFile.previewImage = this.getFileThumbnail(tempFile)
            this.files.push(tempFile)
          }
        })
      }
    },
    onChange(file) {
      if (!this.checkFileProperties(file.raw)) return

      let f = {
        name: file.name,
        extension: file.name.split('.')[1],
        mime: file.raw.type,
        content: file.raw,
        newFile: true,
        previewImage: null,
      }

      f.previewImage = this.getFileThumbnail(f)
      this.files.push(f);

      let inputFiles = this.$refs.attachmentUploader.uploadFiles
      let files = []
      for (let f in inputFiles) {
        if (inputFiles[f].raw) files.push(inputFiles[f].raw)
      }

      this.field_value = files;
      this.updateValue();
    },
    getFileIcon(ext) {
      if (this.extAndIcons.hasOwnProperty(ext)) return '/img/files/' + this.extAndIcons[ext] + '.png'
      return '/img/files/file.png'
    },
    getFileThumbnail(file) {
      if (this.fileIsImage(file.mime)) {
        if (file.newFile) {
          return URL.createObjectURL(file.content)
        }
        return file.download_link
      }
      return this.getFileIcon(file.extension);
    },
    getExtensionFromUrl(url) {
      return url.substring(url.lastIndexOf('/') + 1).split('.')[1];
    },
    fileIsImage(mime) {
      return [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/svg+xml',
        'image/bmp',
        'image/gif',
        'image/webp',
      ].indexOf(mime) !== -1;
    },
    checkFileProperties(file) {
      let fileExt = file.name.split('.');
      if (fileExt.length > 1) {
        fileExt = fileExt[fileExt.length - 1];
      } else {
        fileExt = ''
      }
      let allowedExt = this.allowedExt;
      const validExt = allowedExt.indexOf(fileExt) !== -1;
      const maxMBSize = file.size / 1024 / 1024 <= this.fileSizeLimit; // 2MB max file size

      if (!validExt) {
        this.$message.error('file must be from these formats: ' + allowedExt);
      }
      if (!maxMBSize) {
        this.$message.error(this.$ml.get('file_cant_exceed_size') + this.fileSizeLimit + 'MB');
      }
      return validExt && maxMBSize;
    }
  }
}
</script>

<style>
.el-upload-list--picture-card .el-upload-list__item {
  width: 200px !important;
  height: 180px !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 200px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
</style>
